export default __webpack_public_path__ + "static/media/love-3.578fd660.jpg";